import { render, staticRenderFns } from "./PlushieUpgradeAddForm.vue?vue&type=template&id=fb9d45a2&scoped=true&"
import script from "./PlushieUpgradeAddForm.vue?vue&type=script&lang=ts&"
export * from "./PlushieUpgradeAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieUpgradeAddForm.vue?vue&type=style&index=0&id=fb9d45a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d45a2",
  null
  
)

export default component.exports